var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.86 109.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#f4e11d;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.33,24.51a4.91,4.91,0,0,1,4.91-4.9h14.7a4.91,4.91,0,1,1,0,9.81H68.12a1,1,0,0,0-1,1v7.84a1,1,0,0,0,1,1h8.82a4.91,4.91,0,0,1,4.91,4.9V58.83a4.91,4.91,0,0,1-1.44,3.47L65.7,77a4.9,4.9,0,1,1-6.93-6.93l13-13a1,1,0,0,0,.29-.7V50a1,1,0,0,0-1-1H62.24a4.91,4.91,0,0,1-4.91-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.53,24.51a4.91,4.91,0,0,0-9.81,0V59.34a1,1,0,0,1-1.67.69l-2.94-2.94a1,1,0,0,1-.29-.7V53.93a4.9,4.9,0,0,0-9.8,0v4.9a4.9,4.9,0,0,0,1.43,3.47L39.16,77a4.9,4.9,0,0,0,8.37-3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.15,16.79A14.71,14.71,0,0,1,14.71,0H90.15a14.71,14.71,0,0,1,14.56,16.79L97,70.63a14.71,14.71,0,0,1-4.88,9l-30,26.28a14.71,14.71,0,0,1-19.37,0l-30-26.28a14.71,14.71,0,0,1-4.88-9Zm14.56-7A4.9,4.9,0,0,0,9.86,15.4l7.69,53.85a4.91,4.91,0,0,0,1.62,3l30,26.28a4.92,4.92,0,0,0,6.46,0l30-26.28a4.86,4.86,0,0,0,1.62-3L95,15.4a4.89,4.89,0,0,0-4.85-5.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/JS.822c82559604c82c88008d02a13f78fc.svg";
export { ForwardRef as ReactComponent };